import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/custom.css';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from './dashboardLogo.png';
import styled from 'styled-components';
import swal from 'sweetalert2';
import { useRef } from 'react';

function LayoutPage(props) {
  const [username, setUsername] = useState(null);
  const [userData, setUserData] = useState(null);
  const sidebarScrollRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const isRouteActive = (routes) =>
    routes.some(
      (route) =>
        location.pathname === route ||
        location.pathname.startsWith(`${route}/`),
    );
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem('angolosport_auth_back'));
    // console.warn("checking ------->",user)
    setUserData(user);
    setUsername(user.username);
  }, [username]);
  const handleLogout = () => {
    swal
      .fire({
        title: 'Log out?',
        text: 'You are about to leave the admin panel.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, logout',
      })
      .then((res) => {
        // console.log(res);
        if (res.isConfirmed) {
          localStorage.removeItem('angolosport_auth_back');
          navigate('/');
        }
      });
  };

  useEffect(() => {
    const savedScrollTop = sessionStorage.getItem('adminSidebarScrollTop');
    if (sidebarScrollRef.current && savedScrollTop !== null) {
      requestAnimationFrame(() => {
        sidebarScrollRef.current.scrollTop = Number(savedScrollTop) || 0;
      });
    }
  }, []);

  const handleSidebarScroll = () => {
    if (sidebarScrollRef.current) {
      sessionStorage.setItem(
        'adminSidebarScrollTop',
        String(sidebarScrollRef.current.scrollTop),
      );
    }
  };

  return (
    <Container>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <aside
        className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3"
        id="sidenav-main"
        style={{ width: '18rem' }}
      >
        <div className="sidenav-header">
          <i
            className="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none"
            aria-hidden="true"
            id="iconSidenav"
          ></i>
          {/* <a className="navbar-brand m-0" href="https://demos.creative-tim.com/material-dashboard/pages/dashboard " target="_blank">
                        <span style={{ color: 'white' }}>Welcome </span><span className="ms-1 font-weight-bold text-white"> {username ? username : ''}</span>
                    </a> */}
          <Link className="navbar-brand m-0 new-da" to={'/'}>
            {/* <img src={`${process.env.PUBLIC_URL}/assets/img/final_logo.svg`} alt="" /> */}
            {/* <h5>
              Angolo<span style={{ color: "#990707" }}>sport</span>
            </h5> */}
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
            {/* <span style={{ color: "white" }}>Welcome </span>
            <span className="ms-1 font-weight-bold text-white"> Admin</span> */}
          </Link>
        </div>
        <hr className="horizontal light mt-2 mb-2" />
        <div
          ref={sidebarScrollRef}
          onScroll={handleSidebarScroll}
          className="collapse navbar-collapse  w-auto "
          id="sidenav-collapse-main"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                id="dashboard"
                to="/dashboard"
                className={`nav-link text-white ${
                  isRouteActive(['/dashboard']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    // style={{
                    //   fontSize: "1.4rem"
                    // }}
                    className="material-icons opacity-10 fonts"
                  >
                    dashboard
                  </i>
                </div>
                <span className="nav-link-text ms-1 fonts">Dashboard</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                id="user"
                to="/user"
                className={`nav-link text-white ${
                  isRouteActive(['/user', '/track-user']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-user"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">
                  User Management{' '}
                </span>
              </Link>
            </li>

            {/* <li className="nav-item">
              <Link
                to="/game"
                className={`nav-link text-white ${
                  location.pathname.includes("/game") ? "active " : ""
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-globe fonts"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Game</span>
              </Link>
            </li> */}

            <li className="nav-item">
              <Link
                id="file"
                to="/file"
                className={`nav-link text-white ${
                  isRouteActive(['/file', '/add-file']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-globe fonts"></i>
                </div>
                <span className="nav-link-text fonts">File Uploads</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                id="sports"
                to="/sport-category"
                className={`nav-link text-white ${
                  isRouteActive([
                    '/sport-category',
                    '/category',
                    '/contest-winner',
                  ])
                    ? 'active '
                    : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-list-alt fonts"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">
                  Sports Categories
                </span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                id="noti"
                to="/notification"
                className={`nav-link text-white ${
                  isRouteActive(['/notification']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-bell fonts"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Notifications</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                id="content"
                to="/content"
                className={`nav-link text-white ${
                  isRouteActive(['/content']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-list-alt fonts"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Content Pages</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="researchArt"
                to="/research-articles"
                className={`nav-link text-white ${
                  isRouteActive(['/research-articles']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa-solid fa-newspaper"
                    style={{ fontSize: 'large' }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">
                  Research Articles
                </span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                id="newsArt"
                to="/blogs"
                className={`nav-link text-white ${
                  isRouteActive(['/blogs']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa-solid fa-newspaper"
                    style={{ fontSize: 'large' }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Blogs</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                id="podcast"
                to="/podcast"
                className={`nav-link text-white ${
                  isRouteActive(['/podcast']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa fa-video-camera"
                    style={{ fontSize: 'large' }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Podcasts</span>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
              id="emailMarketing"
                to="/email-marketing"
                className={`nav-link text-white ${
                  location.pathname.includes("/email-marketing") ? "active " : ""
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa fa-heading"
                    style={{ fontSize: "large" }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Email-Marketing</span>
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link
                to="/headline"
                className={`nav-link text-white ${
                  location.pathname.includes("/headline") ? "active " : ""
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa fa-heading"
                    style={{ fontSize: "large" }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Top Headlines</span>
              </Link>
            </li> */}
            <li className="nav-item">
              <Link
                id="lookingFor"
                to="/looking-for"
                className={`nav-link text-white ${
                  isRouteActive(['/looking-for']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa fa-magnifying-glass"
                    style={{ fontSize: 'large' }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Messages</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="ads"
                to="/banner"
                className={`nav-link text-white ${
                  isRouteActive(['/banner']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa-solid fa-rectangle-ad"
                    style={{ fontSize: 'large' }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Banners</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="social"
                to="/social"
                className={`nav-link text-white ${
                  isRouteActive(['/social', '/edit-social']) ? 'active ' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i
                    className="fa-solid fa-thumbs-up"
                    style={{ fontSize: 'large' }}
                  ></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Social Media</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="badges"
                to="/badges"
                className={`nav-link text-white ${
                  isRouteActive(['/badges']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa-solid fa-award"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Badges</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="elo-management"
                to="/elo-management"
                className={`nav-link text-white ${
                  isRouteActive(['/elo-management']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa-solid fa-ranking-star"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">ELO Management</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="challenges"
                to="/challenges"
                className={`nav-link text-white ${
                  isRouteActive(['/challenges']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa-solid fa-bullseye"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Challenges</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="comments"
                to="/comments"
                className={`nav-link text-white ${
                  isRouteActive(['/comments']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa-solid fa-comments"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Comments</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="site-settings"
                to="/site-settings"
                className={`nav-link text-white ${
                  isRouteActive(['/site-settings']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-cog"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">Site Settings</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                id="change-password"
                to="/change-password"
                className={`nav-link text-white ${
                  isRouteActive(['/change-password']) ? 'active' : ''
                }`}
              >
                <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa fa-user"></i>
                </div>
                <span className="nav-link-text ms-1 fonts">
                  Change Password
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </aside>
      <main className="main-working-ar main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <nav
          className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
          id="navbarBlur"
          data-scroll="true"
        >
          <div className="container-fluid py-1 px-3">
            <div
              className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
              id="navbar"
            >
              <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                <div className="input-group input-group-outline"></div>
              </div>
              <ul className="navbar-nav  justify-content-end">
                <li className="nav-item px-3 d-flex align-items-center">
                  <button
                    className="btn admin-logout-button"
                    title="Logout"
                    onClick={handleLogout}
                  >
                    Log Out
                    {/* <i
                      style={{
                        color: "black",
                      }}
                      className="fa fa-lg fa-power-off fixed-plugin-button-nav cursor-pointer"
                    ></i> */}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="container-fluid py-4">
          <div className="main-working-area">
            {props.children}
            {props.withFooter && (
              <footer className="footer py-4  ">
                <div className="container-fluid">
                  <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6 mb-lg-0 mb-4">
                      <div className="copyright text-center text-sm text-muted text-lg-start">
                        © AlgoSports23
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <ul className="nav nav-footer justify-content-center justify-content-lg-end"></ul>
                    </div>
                  </div>
                </div>
              </footer>
            )}
          </div>
        </div>
      </main>
    </Container>
  );
}

export default LayoutPage;

const Container = styled.div`
  .fonts {
    font-size: 0.95rem;
  }
  .sidenav {
    background-color: #232b4a;

    .sidenav-header {
      margin-bottom: 20px;
      .navbar-brand {
        .logo {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 86px;
            height: 86px;
            margin: 0;
          }
        }
      }
    }

    .collapse {
    }
  }
`;
